import { Field } from "@/widgets/classic-form/form";
import type { CategoryBucketAttributes } from "@/entities/form-metadata";
import { Grid } from "@/shared/components/Grid";
import { useCategoryBucketTracking } from "./useCategoryBucketTracking";
import styles from "./CategoryBucket.module.scss";

type BucketKey = keyof CategoryBucketAttributes["buckets"];

export const CategoryBucket = ({ buckets }: CategoryBucketAttributes) => {
    const trackBucketChange = useCategoryBucketTracking();
    const visibleBuckets = (Object.keys(buckets) as BucketKey[]).filter((key) => buckets[key].show);

    return (
        <Grid.Container className={styles.categoryBucket}>
            {visibleBuckets.map((bucketKey) => (
                <Grid.Field key={`type_${bucketKey}`} spanDesktop={6} spanTablet={6} spanMobile={12}>
                    <Field name={`types.${bucketKey}`}>
                        {(field) => (
                            <div>
                                <input
                                    id={bucketKey}
                                    type="checkbox"
                                    className="checkbox"
                                    checked={field.value}
                                    onChange={() => {
                                        const next = !field.value;
                                        trackBucketChange(bucketKey, next);
                                        field.onChange(next);
                                    }}
                                />
                                <label htmlFor={bucketKey}>{buckets[bucketKey].label}</label>
                            </div>
                        )}
                    </Field>
                </Grid.Field>
            ))}
        </Grid.Container>
    );
};
